// Page atteinte quand un user connecté sans abo Coach Pro tente d'ouvrir
// le Dashboard Coach depuis le web. Historiquement c'était un tunnel Stripe :
// depuis qu'on a retiré la gestion des abonnements côté site (tout se fait
// désormais via RevenueCat dans l'app), cette page explique simplement où
// souscrire et propose les liens de téléchargement.
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, verifySession } from "../services/authService";
import Tiggy from "../site/Tiggy";
import BoutonsStores from "../site/BoutonsStores";

function ProUpgrade() {
	const navigate = useNavigate();

	useEffect(() => {
		const checkSession = async () => {
			if (!isLoggedIn()) {
				navigate("/login");
				return;
			}
			const isValid = await verifySession();
			if (!isValid) navigate("/login");
		};
		checkSession();
	}, [navigate]);

	return (
		<section className="gs-page">
			<div className="gs-quadrillage gs-quadrillage--page" />
			<div className="gs-conteneur">
				<div className="gs-carte gs-page-carte">
					<Tiggy pose="croissance" taille={150} />
					<span className="gs-surtitre">GymNote Pro</span>
					<h1 className="gs-page-titre">Le dashboard coach web est réservé aux abonnés Pro</h1>
					<p className="gs-texte">La souscription se fait directement dans l'app mobile GymNote.</p>
					<ol className="gs-etapes">
						<li>Ouvre l'app GymNote sur ton téléphone</li>
						<li>
							Va dans <em>Mon compte → Abonnement</em>
						</li>
						<li>
							Choisis <strong>Pro</strong> et suis les instructions
						</li>
						<li>Reviens sur cette page une fois l'abonnement actif</li>
					</ol>
					<BoutonsStores />
					<button type="button" className="gs-lien" onClick={() => navigate(-1)}>
						Retour
					</button>
				</div>
			</div>
		</section>
	);
}

export default ProUpgrade;
